import { useEffect } from "react";

import { RouteDefinition } from "components/router/Routes";

// Survives remounts, which happen on every sub menu item click, so it can tell whether the previously
// active main route differs from the current one.
let previousMainRoute: RouteDefinition | undefined;

export function useHasEnteredNewMainRoute(mainRoute?: RouteDefinition): boolean {
    const hasEnteredNewMainRoute = mainRoute !== undefined && previousMainRoute !== mainRoute;

    useEffect(() => {
        previousMainRoute = mainRoute;
    }, [mainRoute]);

    return hasEnteredNewMainRoute;
}
